const STORAGE_KEY = 'new-courses-panel-closed-at';
const HIDE_FOR_MS = 24 * 60 * 60 * 1000;

/**
 * Panneau « Nouvelles formations » des pages Formation : rendu masqué, affiché
 * au chargement sauf s'il a été fermé depuis moins de 24 h. L'heure de fermeture
 * reste dans le navigateur ; sans stockage disponible (navigation privée,
 * stockage bloqué), le panneau s'affiche simplement à chaque page.
 */
export function initNewCoursesPanel(): void {
    const panel = document.querySelector<HTMLElement>('[data-new-courses-panel]');
    if (!panel) {
        return;
    }

    let closedAt = 0;
    try {
        closedAt = parseInt(window.localStorage.getItem(STORAGE_KEY) ?? '', 10) || 0;
    } catch {
        closedAt = 0;
    }
    if (closedAt && Date.now() - closedAt < HIDE_FOR_MS) {
        return;
    }

    panel.classList.remove('hidden');

    panel.querySelector<HTMLButtonElement>('[data-new-courses-panel-close]')?.addEventListener('click', () => {
        panel.classList.add('hidden');
        try {
            window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch {
            // Stockage indisponible : le panneau reviendra à la page suivante.
        }
    });
}
